import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, MenuItem, Paper, Popover, TextField, Tooltip, Typography } from '@material-ui/core'
import { InfoOutlined, KeyboardArrowDown } from '@material-ui/icons'
import _ from 'lodash'
import Breadcrumb from '../../Components/Breadcrumbs'
import { useStyles } from './style'
import { AppButton, Loader } from '../../Components'
import { Cards, TableOutline } from '../../elements'
import copy from '../../Assets/Images/copy.svg'
import eye from '../../Assets/Images/eye.svg'
import hideeye from '../../Assets/Images/hideeye.svg'
import edit from '../../Assets/Images/edit.svg'
import deleteIcon from '../../Assets/Images/delete.svg'
import { tableHeadings } from './constant'
import { developerHubService } from '../../Services'
import { accountService } from '../../Services/AccountService/AccountService'
import * as messageTypes from '../../utils/messageTypes'
import DisplayMessage from '../../Components/DisplayMessage'
import CustomDialog from '../../Components/CustomDialog'
import * as yup from 'yup'
import { useFormik } from 'formik'
import ProgramOAuth from './ProgramOAuth'

const validationSchema = yup.object({
  clientName: yup.string('Enter client name').required('App client name is required').max(20, 'App client name must be max 20 characters').matches(/(^[\w\s+=,.@-]+)$/, 'Only alphanumeric characters, spaces and +=,_.@- are allowed'),
})

function ApiDashboard(props) {
  const classes = useStyles()
  const [tableData, setTableData] = useState([])
  const [clientData, setClientData] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [infoAnchorEl, setInfoAnchorEl] = useState(null)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(props.isSuperAdmin ? '' : { id: props.currentUser.account_id })
  const [appClientModal, setAppClientModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [showSecret, setShowSecret] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [editData, setEditData] = useState('')
  const [deleteData, setDeleteData] = useState('')
  const [prefilledClientName, setPrefilledClientName] = useState('')
  const [showProgramOAuthCard, setShowProgramOAuthCard] = useState(false)
  const { currentUser } = props

  const formik = useFormik({
    initialValues: {
      clientName: _.get(editData, 'clientName', prefilledClientName)
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      submitForm(values, resetForm)
    },
  })

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleInfoClick = (event) => {
    setInfoAnchorEl(event.currentTarget)
  }

  const handleInfoClose = () => {
    setInfoAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  const openInfo = Boolean(infoAnchorEl)
  const infoId = openInfo ? 'dropsown-popover' : undefined

  const submitForm = (values, resetForm) => {
    setLoading(true)
    developerHubService.submitClientForm(values, selectedAccount, clientData, currentUser.account_id, editData, props.isSuperAdmin)
      .then(clientData => {
        setLoading(false)
        setOpen(true)
        setMessage(editData ? 'Client updated successfully' : 'New client generated successfully')
        setMessageType(messageTypes.SUCCESS)
        resetForm()
        setAppClientModal(false)
        getClientKeys()
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const deleteClient = () => {
    setLoading(true)
    developerHubService.deleteClient(currentUser, selectedAccount, deleteData, props.isSuperAdmin)
      .then(data => {
        setLoading(false)
        setOpen(true)
        setMessage('Client id deleted successfully from account')
        setMessageType(messageTypes.SUCCESS)
        setDeleteModal(false)
        getClientKeys()
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getClientKeys = () => {
    setLoading(true)
    developerHubService.getClientKeys(currentUser.account_id, selectedAccount.id, props.isSuperAdmin)
      .then(clientKeysData => {
        setClientTable(clientKeysData.apiClientList)
        setClientData(clientKeysData)
        let initialShowValues = clientKeysData.apiClientList ? Array(clientKeysData.apiClientList.length).fill(false) : []
        setShowSecret(initialShowValues)
        getPrefilledClientName(clientKeysData.apiClientList)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const setClientTable = (appClientData) => {
    let appClientTable = []
    appClientData.map((obj, index) => {
      let tableObj = [
        {
          id: 'appClientName',
          className: classes.tableClientName,
          value: <Box display="flex" justifyContent="space-between" alignItems="center" pr={2}>
            <Box>{_.get(obj, 'clientName', '-')}</Box>
            <Box mx={0.5}><img src={edit} className={classes.tableIcons} color="primary" onClick={() => { setEditData(obj); setAppClientModal(true) }} /></Box>
          </Box>,
        },
        {
          id: 'clientId',
          className: classes.tableClientId,
          value: <Box display="flex" justifyContent="space-between" pr={2}>
            <Box mr={1}>{_.get(obj, 'clientId', '-')}</Box>
            <Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(obj, 'clientId', '-'))} /></Tooltip>
          </Box>,
        },
        {
          id: 'clientSecret',
          className: classes.tableClientSecret,
          value: <Box>
            {showSecret[index] ?
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>{_.get(obj, 'clientSecret', '-')}</Box>
                <Box display="flex">
                  <Box display="flex" mx={1}><Tooltip title="hide" arrow placement="top-start"><img className={classes.tableIcons} src={hideeye} alt="" onClick={() => toggleSecretVisibility(index)} /></Tooltip></Box>
                  <Box display="flex" mx={1}><Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(obj, 'clientSecret', '-'))} /></Tooltip></Box>
                </Box>
              </Box> :
              <Box px={5}>
                <Tooltip title="show" arrow placement="top-start"><img className={classes.tableIcons} src={eye} alt="" onClick={() => toggleSecretVisibility(index)} /></Tooltip>
              </Box>}
          </Box>,
        },
        {
          id: 'actions',
          className: classes.tableActions,
          value: <Box display="flex">
            <Box width="100%"><img src={deleteIcon} className={classes.tableIcons} color="primary" onClick={() => { setDeleteData(obj); setDeleteModal(true) }} /></Box>
          </Box>
        }
      ]
      appClientTable.push(tableObj)
    })
    setTableData(appClientTable)
  }

  const getPrefilledClientName = (apiClientList) => {
    for (let i = 1; i <= 6; i++) {
      if (!apiClientList.some(apiClient => apiClient.clientName === `App_Client_Name_${i}`)) {
        setPrefilledClientName(`App_Client_Name_${i}`)
        break
      }
    }
  }

  const toggleSecretVisibility = (index) => {
    let secretVisibility = []
    secretVisibility = [...showSecret]
    secretVisibility[index] = !showSecret[index]
    setShowSecret(secretVisibility)
  }

  const copyToClipboard = (text) => {
    if (!navigator.clipboard) {
      setOpen(true)
      setMessage('Failed to copy')
      setMessageType(messageTypes.ERROR)
      return
    } else {
      navigator.clipboard.writeText(text)
      setOpen(true)
      setMessage('Text Copied!')
      setMessageType(messageTypes.INFO)
    }
  }

  const getAllAccounts = () => {
    setLoading(true)
    accountService.getAllAccounts(currentUser.account_id)
      .then(accountsData => {
        setAccounts(accountsData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getCardValues = () => {
    return (
      <>
        {selectedAccount ?
          <>
            <Box className={classes.apiKeyBox} display="flex" flexWrap="wrap">
              <Box display="flex" mx={1} alignItems="center"><Typography className={classes.apiKey}>API KEY</Typography>
                <InfoOutlined style={{ color: '#707070', fontSize: 18, cursor: 'pointer' }} onClick={handleInfoClick} />
                <Popover
                  id={infoId}
                  open={openInfo}
                  anchorEl={infoAnchorEl}
                  onClose={handleInfoClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    className: classes.infoPopoverPaper,
                  }}
                >
                  <Box className={classes.infoPopover} p={1.5}>
                    {'Unique for the account and must be included as part of each API request. Used to authenticate the application and track usage'}
                  </Box>
                </Popover>
              </Box>
              <Box display="flex" mx={1} alignItems="center"><Typography className={classes.apiKeyValue}>{_.get(clientData, 'apiKeys[0]', '-')}</Typography>
                {_.get(clientData, 'apiKeys[0]') && <Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(clientData, 'apiKeys[0]', '-'))} /></Tooltip>}
              </Box>
            </Box>
            <Box>
              <TableOutline
                tableHeadings={tableHeadings(classes)}
                tableData={tableData}
                pagination={false}
              />
            </Box>
          </>
          :
          <Paper elevation={2} className={classes.cardsWrapper}>
            <Box className={classes.selectMessageWrapper}>
              Please select an account
            </Box>
          </Paper>
        }
      </>
    )
  }

  const getProgramOAuthCardValues = () => (
    <Box>
      <ProgramOAuth
        accountId={selectedAccount.id}
        isSuperAdmin={props.isSuperAdmin}
        setShowProgramOAuthCard={setShowProgramOAuthCard}
        setOpen={setOpen}
        setMessage={setMessage}
        setMessageType={setMessageType}
        messageTypes={messageTypes}
        copyToClipboard={copyToClipboard}
        loading={loading} />
    </Box>
  )

  const getAppClientModalContent = () => (
    <form onSubmit={formik.handleSubmit}>
      <Box mb={2} mx={2}>
        <TextField
          id="clientName"
          name="clientName"
          label='App Client Name'
          value={formik.values.clientName}
          onChange={formik.handleChange}
          fullWidth
          error={formik.touched.clientName && Boolean(formik.errors.clientName)}
          helperText={formik.touched.clientName && formik.errors.clientName}
        />
      </Box>
      <AppButton type="submit" text='Submit' />
    </form>
  )

  const getDeleteModalContent = () => (
    <Box>
      <Typography className={classes.deleteModalText}>Are you sure you want to delete the App Client <b>"{_.get(deleteData, 'clientName', '')}"</b>?</Typography>
      <Box display="flex" justifyContent="space-around" mt={3}>
        <AppButton className={classes.deleteModalButton} text="YES, DELETE" onClick={() => deleteClient()} />
        <AppButton className={classes.deleteModalButton} text="NO" fill={false} onClick={() => setDeleteModal(false)} />
      </Box>
    </Box>
  )

  useEffect(() => {
    if (props.isSuperAdmin) {
      getAllAccounts()
    }
  }, [props.isSuperAdmin])

  useEffect(() => {
    if (clientData && clientData.apiClientList) {
      setClientTable(clientData.apiClientList)
    }
  }, [showSecret])

  useEffect(() => {
    if (selectedAccount) {
      getClientKeys()
    }
  }, [selectedAccount])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'API Credentials': '/developer/api-credentials' }]} />
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <CustomDialog open={appClientModal} fullWidth maxWidth="xs" title={`${editData ? 'Edit' : 'Create New'}  App Client`} content={getAppClientModalContent()} handleClose={() => { setAppClientModal(false) }} />
      <CustomDialog open={deleteModal} fullWidth maxWidth="xs" title="" content={getDeleteModalContent()} handleClose={() => { setDeleteModal(false) }} />
      <Box className={classes.headerWrapper}>
        <Box my={1}>
          <Typography className={classes.title}>API Credentials</Typography>
          <Box className={classes.subTitle}>Track all your app clients here or create new ones</Box>
        </Box>
        <Box display="flex" flexWrap="wrap">
          {selectedAccount &&
            <>
              <AppButton className={classes.buttons} text="Create New App Client" onClick={() => { setEditData(''); setAppClientModal(true) }} />
              {/* <AppButton className={classes.buttons} text="View Statistics" /> */}
            </>
          }
          {props.isSuperAdmin &&
            <Box>
              <AppButton aria-describedby={id} className={classes.buttons} text={
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box className={classes.paperText}>{selectedAccount ? `ACCOUNT | ${selectedAccount.company_name}` : 'SELECT ACCOUNT'}</Box>
                  <KeyboardArrowDown />
                </Box>
              } onClick={handleClick} />
              <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                classes={{ paper: classes.paper }}
              >
                {accounts.map(account => account && account.apiAccess && account.apiAccess === true && (
                  <MenuItem key={account.id} value={account.id} onClick={() => { setSelectedAccount(account); handleClose() }}>
                    <Box display="flex" justifyContent="space-between" width="100%">
                      <Box component="span">
                        {account.company_name}
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Popover>
            </Box>
          }
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={getCardValues()} />
      {selectedAccount && <Cards className={`${showProgramOAuthCard ? classes.cardWrapper : classes.hideCard}`} children={getProgramOAuthCardValues()} />}
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(ApiDashboard)